module.exports = __webpack_public_path__ + "img/cancercouncil-nt.f1c913b.png";